module.exports = __webpack_public_path__ + "media/images/como_funciona/payment-e48d18207da3742b8943545658e3c04c.png";